/** Convert campaign copy only; product prices remain controlled by Shopify Markets. */
export function campaignMoney(amount, base, currency, rate, locale) {
  if (!Number.isFinite(amount) || amount < 0) return null;
  const converted = currency !== base;
  if (converted && (!Number.isFinite(rate) || rate <= 0)) return null;
  try {
    const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' });
    return `${formatter.format(amount * (converted ? rate : 1))} ${currency}`;
  } catch { return null; }
}
class EchtPBMoney extends HTMLElement {
  connectedCallback() {
    const current = window.Shopify?.currency;
    if (!current?.active) return;
    for (const node of this.querySelectorAll('[data-pb-amount]')) {
      const label = campaignMoney(Number(node.dataset.pbAmount), this.dataset.baseCurrency, current.active, Number(current.rate), document.documentElement.lang);
      if (label) node.textContent = label;
    }
  }
}
if (!customElements.get('echt-pb-money')) customElements.define('echt-pb-money', EchtPBMoney);
